import React from 'react';
import './index.css';
import Toast from '../common/Toast'
import util from "../../util/tools";
import commonTools from "../../../common/util/util";

export default class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            weixinurl: "",
            bookId: "",
            text:'',
            successBl: false
        };
    }

    componentDidMount() {
        document.title = '双旦狂欢'
        this.setState({
            bookId: this.props.match.params.bookId,
            weixinurl: this.props.match.params.weixinurl,
            successBl: commonTools.searchPar().paysuccess == 1
        })
    }

    showText(text){
        this.setState({
            text:text
        },()=>{
            setTimeout(()=>{
                this.setState({
                    text:"",
                })
            },2000)
        })
    }

    recharge(item,index){
        let url = this.state.weixinurl || `${document.location.href}`;
        if(url.indexOf("?")>=0){
            url = url.substr(0,url.indexOf("?"));
        }
        let back_url = url;
        if(back_url.indexOf("?")>=0){
            back_url = back_url + "&paysuccess=1";
        }else{
            back_url = back_url + "?paysuccess=1";
        }
        let params = {
            'total_fee':item*100,
            'active': 1,
            'back_url':back_url,
            'error_url':url,
        }
        if(!!this.state.bookId){
            params.book_id = this.state.bookId
        }
        util.ajax({
            url: "/zh/pay/wgpay",
            method:'post',
            isUser: true,
            isWechatId: true,
            data: params,
            callback: res => {
                if (res.result.status.code == 0) {
                    document.location.href = res.result.data.url
                } else {
                    this.showText(res.result.status.msg);
                }
            }
        });
    }

    goRoute(url){
        this.props.history.push(`/${url}`)
    }

    render() {
        return (
            <div className='payactivity'>
                <img src={require("../../../common/images/sdhdIMG.jpg")} className="hdIMG" />
                {[12,25,88].map((item,index)=>(<a className={`a_btn btn${index}`} onClick={()=>this.recharge(item,index)} key={`r${index}`}></a>))}
                <Toast text={this.state.text}/>
                {
                    !!this.state.successBl &&
                    <div className="paySuccessBox">
                        <div className="tempBox">
                            <img src={require("../../../common/images/tcIMG.png")} className="payIMG" />
                            <div className='a_btn btn1' onClick={()=>this.setState({successBl:false})}>返回</div>
                            <div className='a_btn btn2' onClick={()=>this.goRoute("recentlyread")}>进入书架</div>
                            <div className='a_btn btn3' onClick={()=>this.setState({successBl:false})}>关闭</div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}